import router from "../../router";

/**
 * 外部のAPIを呼び出すクラス
 *
 * バックエンドをラッパして動かす
 * 別のバックエンド（例：モック等）で動かす場合は、envファイルの設定値で差し替える
 * ※バックエンドは動的にインポートする
 */
class Api {
  _apiBackend = null;

  /**
   * 接続先バックエンドの取得
   */
  async importBackend() {
    if (process.env.VUE_APP_API_BACKEND_MOCK_USE == "true") {
      // モックデータから取得する
      return import("@/mock-data/api-backend");
    } else {
      // 実際のAPIから取得する
      return import("@/logic/api/api-backend");
    }
  }

  /**
   * バックエンドの参照
   */
  async backend() {
    if (this._apiBackend) {
      return this._apiBackend;
    }
    const backend = await this.importBackend();
    if (this._apiBackend == null) {
      this._apiBackend = backend.default;
    }
    return this._apiBackend;
  }

  /**
   * APIを実行する
   * @param {URLのパス} key
   * @param {Bodyなどのリクエストパラメータ} parameter
   * @returns データを返却するPromiseオブジェクト
   */
  async call(key, parameter) {
    // バックエンドを参照する
    const backend = await this.backend();
    // 参照したバックエンドに、API呼び出しを要求する
    return backend.call(backend.target(key), parameter);
  }

  async callFormData(key, formData) {
    // バックエンドを参照する
    const backend = await this.backend();
    // 参照したバックエンドに、API呼び出しを要求する
    return backend.callFormData(backend.target(key), formData);
  }

  /**
   * APIを繰り返し実行する
   * @param {URLのパス} key
   * @param {Bodyなどのリクエストパラメータの配列} parameters
   * @returns データを返却するPromiseオブジェクト
   */
  async repeatCall(key, parameters) {
    // バックエンドを参照する
    const backend = await this.backend();
    // パラメータの件数分だけAPIを実行する
    return Promise.all(
      parameters.map((parameter) => {
        return backend.call(backend.target(key), parameter);
      })
    );
  }

  /**
   * エラーを解決する
   * @param {エラーコンテンツ} error
   */
  resolve(error) {
    console.log(error);
    if (error.resolve) {
      error.resolve();
    } else {
      router.push("/error");
    }
  }
}

export default new Api();
